import type { Requests } from "../common/request.common";
import type { FinanceDisbursementResponseTypes } from "../common/response.common";
import { get, post, postEmpty } from "./common";

export const financeDisbursement = {
    record(data: typeof Requests.FinanceDisbursement.Record.Input) {
        return post<typeof data, FinanceDisbursementResponseTypes.Record>(
            `/finance-disbursement/record`,
            data,
        );
    },
    balance() {
        return get<FinanceDisbursementResponseTypes.Balance>(`/finance-disbursement/balance`);
    },
    create(data: typeof Requests.FinanceDisbursement.Create.Input) {
        return post<typeof data>(`/finance-disbursement/create`, data);
    },
    obtain(id: string) {
        return get<FinanceDisbursementResponseTypes.Obtain>(`/finance-disbursement/obtain/${id}`);
    },
    resolveSuccess(id: string) {
        return postEmpty(`/finance-disbursement/resolve-success/${id}`);
    },
    resolveFailure(id: string) {
        return postEmpty(`/finance-disbursement/resolve-failure/${id}`);
    },
    calculateFee(data: typeof Requests.FinanceDisbursement.CalculateFee.Input) {
        return post<typeof data, FinanceDisbursementResponseTypes.CalculateFee>(
            `/finance-disbursement/calculate-fee`,
            data,
        );
    },
};
